import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { getDonationDetail } from "../api/getDonationDetail";
import currencyFormatter from "currency-formatter";
import rackerLogo from "../images/racker-logo.png";
import SocialComponent from "../components/social-component";
const currencies = require("../data/currencies.json");

const charityNames = {
  913288: "Nova Ukraine",
  899398: "Razom",
  1000046: "Revived Soldiers Ukraine",
  1051340: "USA for UNHCR",
};

const reactToPdf = () => {
  window.print();
};

const ThankYouPage = (match) => {
  const query = new URLSearchParams(match.location.search);
  const [donationDetail, setDonationDetail] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (donationDetail === undefined) {
      (async () => {
        setLoading(true);
        const id = query.get("session_id");
        const detail = await getDonationDetail(id);
        setDonationDetail(detail.response);
        setLoading(false);
      })();
    }
  }, [query, donationDetail]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Purple Header */}
      <div className="text-white py-12 pb-20" style={{ backgroundColor: '#7f0b86' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-center">Thank You!</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12">
        {/* Main Card */}
        <div className="bg-white rounded-lg shadow-lg border border-gray-300 pb-6 px-6">
          <img 
            src={rackerLogo}
            alt="Racker Logo" 
            className="w-full max-h-36 object-contain mb-6"
          />
          
          {/* Success Message */}
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Your Donation Has Been Received!</h2>
            <p className="text-gray-600">Thank you for supporting the Racker2Racker program</p>
          </div>

          {/* Receipt Section */}
          <div className="border-t pt-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Donation Receipt</h3>
            
            {loading ? (
              <div className="flex items-center justify-center py-8">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2" style={{ borderColor: '#7f0b86' }}></div>
                <span className="ml-3 text-gray-600">Loading receipt...</span>
              </div>
            ) : donationDetail ? (
              <div className="space-y-3">
                <div className="grid grid-cols-2 gap-4 py-3 border-b border-gray-200">
                  <span className="text-gray-600">Date:</span>
                  <span className="font-medium text-right">
                    {new Date(donationDetail.created * 1000).toLocaleDateString('en-US', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </span>
                </div>

                <div className="grid grid-cols-2 gap-4 py-3 border-b border-gray-200">
                  <span className="text-gray-600">Donor:</span>
                  <span className="font-medium text-right">{donationDetail.name}</span>
                </div>

                <div className="grid grid-cols-2 gap-4 py-3 border-b border-gray-200">
                  <span className="text-gray-600">Amount:</span>
                  <span className="font-bold text-lg text-right" style={{ color: '#7f0b86' }}>
                    {currencyFormatter.format(
                      donationDetail.amount / currencies[donationDetail.currency.toLowerCase()],
                      { code: donationDetail.currency }
                    )}
                  </span>
                </div>

                <div className="grid grid-cols-2 gap-4 py-3 border-b border-gray-200">
                  <span className="text-gray-600">Recipient:</span>
                  <span className="font-medium text-right">Racker2Racker Fund</span>
                </div>

                {/* Tax Information */}
                <div className="bg-gray-50 rounded-lg p-4 mt-6">
                  <h4 className="font-semibold text-gray-800 mb-2">Tax Information</h4>
                  <div className="text-sm text-gray-600 space-y-2">
                    <p>No goods or services were provided in exchange for this contribution.</p>
                    <p>The Givinga Foundation is an exempt organization as described in Section 501(c)(3) of the Internal Revenue Code with EIN # 47-4172718.</p>
                    <p>All transactions are processed by the Givinga Foundation; your bank/credit card statements will reflect payments to the Givinga Foundation.</p>
                  </div>
                </div>

                {/* Print Button */}
                <div className="flex justify-center mt-6">
                  <button
                    onClick={() => reactToPdf()}
                    className="flex items-center gap-2 px-6 py-3 text-white rounded-full font-medium transition duration-200"
                    style={{ backgroundColor: '#7f0b86' }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#6a0973'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#7f0b86'}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
                    </svg>
                    Print Receipt
                  </button>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <p className="text-red-600">Failed to load receipt information</p>
              </div>
            )}
          </div>

          <SocialComponent />
        </div>
      </div>
    </div>
  );
};

export default withRouter(ThankYouPage);
